import getGraphQlClient from '~graphql/getGraphQlClient';
import { UPDATE_ANNUNCIO_FUNEBRE } from '~graphql/queries/necrologi';

export default async function updateAnnuncioFunebre(id, fields) {
  const graphQlClient = await getGraphQlClient();

  const response = await graphQlClient.mutate({
    mutation: UPDATE_ANNUNCIO_FUNEBRE,
    variables: { id, fields },
  });

  return response.data.updateAnnunci_funebri.annunci_funebri.objectId;
}
